import { gql } from '__generated__'

export const MarketingListAddParcel = gql(/* GraphQL */`
  mutation MarketingListAddParcel($parcelId: ID!, $listId: ID!) {
    marketingListAddParcel(parcelId: $parcelId, listId: $listId) {
      ... on MarketingListNotFoundError {
        message
        field
      }
      ... on MarketingListParcelNotFoundError {
        message
        field
      }
      ... on MarketingListUnsupportedTypeError {
        message
        field
      }
      ... on MarketingList {
        id
        name
        createdAt
        updatedAt
        type
        itemStats {
          skiptraced
          skiptracing
          total
        }
      }
    }
  }
`)
